// ANCHOR Model
import createModel, { createSelector } from 'react-scoped-model';

// ANCHOR SWR
import useSWR from 'swr';

// ANCHOR API
import { getCourseInstructorCheck } from '@lyon/utils/api/course-instructor';

// ANCHOR Graph State
import { useAuthToken } from '@lyon/nodes/firebase/auth/auth-token-node';
import { useAuthState } from '@lyon/nodes/firebase/auth/auth-state-node';

interface IProps {
  courseId: string;
}

export const CourseInstructorCheck = createModel(
  ({ courseId }: IProps) => {
    const token = useAuthToken();
    const user = useAuthState();

    const response = useSWR(
      ((user && token)
        ? `/course/${courseId}/instructor/${user.uid}`
        : null
      ),
      () => (
        (user && token)
          ? getCourseInstructorCheck({
            courseId,
            token,
            userId: user.uid,
          })
          : undefined
      ),
    );

    const type = typeof token === 'string'
      ? response.data
      : token;

    return {
      data: response.data ?? type,
    };
  },
  {
    displayName: 'Models.CourseInstructorCheck',
  },
);

export const useCourseInstructorCheckData = createSelector(
  CourseInstructorCheck,
  (state) => state.data,
);
